import { useSelector } from 'react-redux';
import { getAuthProps } from '@topconagriculture/auth';
import { useFarmId } from './useFarmId';
import { useCallback } from 'react';
import { useSocketTopicSubscription } from '@topconagriculture/react-socket-notification';
import { useInventoryQuery } from './useInventoryQuery';
export const useInventorySubscription = () => {
    const { refetch, data } = useInventoryQuery();
    const user = useSelector(getAuthProps);
    const farmId = useFarmId();
    const recipients = [farmId, user.companyId, user.userId];
    const onMessage = useCallback(() => {
        refetch();
    }, [refetch, farmId]);
    useSocketTopicSubscription({ topic: 'TMR:WIDGET_INVENTORY', recipients, onMessage });
    return data;
};
//# sourceMappingURL=useInventorySubscription.js.map